import StyleSelect from "../../piece/StyleSelect";
import {Modal} from "antd";
import React, {useEffect, useState} from "react";
import {AreaChartOutlined} from "@ant-design/icons";
import FilterButton from "../../piece/FilterButton";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    const [value, setValue] = useState(null)
    useEffect(() => {
        setDefaultValue(props.defaultValue)
    }, [props])

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <AreaChartOutlined/> Style
            </FilterButton>
            <Modal
                title='Style Filter'
                visible={visible}
                onOk={() => {
                    if (props.onChange) {
                        props.onChange({
                            styleFilter: {
                                text: 'Style:',
                                value: value
                            },
                        })
                    }
                    setVisible(false)
                }}
                onCancel={() => {
                    setVisible(false)
                }}
                destroyOnClose={true}
            >
                <StyleSelect
                    defaultValue={defaultValue}
                    onChange={setValue}
                />
            </Modal>
        </>
    )
}